export default "__VITE_ASSET__BYV$Ye5f__"